var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.label
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }